module.exports = __webpack_public_path__ + "img/eres_8_steps_fr.42cc6172.jpg";